import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { initializeCacheManager } from './utils/cacheManager';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Initialize cache management
initializeCacheManager();

root.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>
);